module.exports = __webpack_public_path__ + "assets/images/glasses-04.c8144c38f5e652cd5a13e90752c3abb7.svg";